export function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = function (event) {
      const image = new Image();
      if (typeof event.target?.result == 'string') {
        image.onload = function () {
          resolve({ width: image.width, height: image.height });
        };
        image.src = event.target.result;
      } else {
        reject();
      }
    };
    reader.readAsDataURL(file);
  });
}

export const waitForImagesToLoad = (element: HTMLElement): Promise<void> => {
  const images = Array.from(element.querySelectorAll('img'));
  const promises = images.map((img) => {
    const isImageValid = img.complete && img.naturalHeight !== 0;
    if (isImageValid) return Promise.resolve();
    return new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = () => reject(new Error(`Image failed to load: ${img.src}`));
    });
  });
  return Promise.allSettled(promises).then(() => undefined);
};
